import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const Logo = styled.img`
  background-color: ${COLORS.BLACK};
  padding: 15px 38px;
  box-sizing: content-box;
  width: 190px;
`;
const ItemText = styled.p`
  font-weight: 600;
`;

const Blinking = styled.svg`
  -webkit-animation: 1s blink ease infinite;
  -moz-animation: 1s blink ease infinite;
  -ms-animation: 1s blink ease infinite;
  -o-animation: 1s blink ease infinite;
  animation: 1s blink ease infinite;
  width: 10px;
  height: 10px;

  @keyframes blink {
    from,
    to {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }

  @-moz-keyframes blink {
    from,
    to {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }

  @-webkit-keyframes blink {
    from,
    to {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }

  @-ms-keyframes blink {
    from,
    to {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }

  @-o-keyframes blink {
    from,
    to {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }
`;

export { Logo, ItemText, Blinking };
